import { drawer_animation_done, _drawer, vis_desktop_nav } from 'state/store.global'
import { useAtom } from 'state/jotai'
import { AnimatePresence, motion } from 'framer-motion'
import { useBreak } from 'hooks/useBreak'
import { Aside } from './Drawer.style'
import { Filter } from 'components/Filter/Filter'
import { UnitDrawer } from 'components/Unit'
import { ViewList } from 'pages/View.List'
import { useMediaQuery } from '@mui/material'
import { useLocation } from 'react-router-dom'

export const Drawer = ({ filter, sorter, detail, list, w, style }) => {
  const drawer = useAtom(_drawer)[0]
  const isFilter = drawer.filter && filter
  const isDetail = drawer.detail && detail
  const isList = drawer.list && list
  const here = useLocation().pathname
  const isIsometry = here.includes("isometry")

  return (
    <AnimatePresence>
      {isFilter && (
        <AnimatedDrawer left filter={filter} style={style}>
          <Filter />
        </AnimatedDrawer>
      )}
      {isDetail && (
        <AnimatedDrawer w={450} right>
          <UnitDrawer />
        </AnimatedDrawer>
      )}
      {isList && (
        <AnimatedDrawer
          left
          w="40vw"
          list={list}
          // ✅ only List Drawer affects isometry layout
          isIsometry={isIsometry}
        >
          <ViewList />
        </AnimatedDrawer>
      )}
    </AnimatePresence>
  )
}

const AnimatedDrawer = ({
  left,
  right,
  children,
  w,
  filter,
  style,
  isIsometry,
  list,
}) => {
  const matches = useMediaQuery('(max-width:1600px)')
  const setState = useAtom(drawer_animation_done)[1]
  const nav = useAtom(vis_desktop_nav)[0]
  const isMobile = useBreak('md_dn')

  // ✅ On mobile drawers slide vertically
  const y_out = isMobile ? '100%' : 0
  const y_in = 0

  // ✅ Drawer slide direction
 const wValue = typeof w === "number" ? `${w}px` : w;

const x_out = isMobile
  ? 0
  : left
  ? `calc(-${nav ? 300 : 0}px - ${wValue})`
  : `calc(${wValue})`;
  const x_in = 0

  // ✅ If it's a list drawer and isometry is active, we apply shifting logic
  const shiftIsometry = list && isIsometry

  const aside = {
    initial: { x: x_out, y: y_out },
    animate: { x: x_in, y: y_in },
    exit: { x: x_out, y: y_out },
    transition: { duration: 0.3, ease: 'linear' },
  }

  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5, ease: 'linear' },
  }

  return (
    <Aside
      {...(filter ? animation : aside)}
      layout
      as={motion.aside}
      left={left?.toString()}
      right={right?.toString()}
      w={w}
      nav={nav}
      // ✅ prevent isometry shifting unless it's the list drawer
      isIsometry={shiftIsometry}
      list={list}
      matches={matches}
      filter={filter}
      style={style}
      // onAnimationStart={() => setState(false)} // creating a animation glitch because multi drawer is present
      // onAnimationComplete={() => setState(true)}
    >
      {children}
    </Aside>
  )
}
